<template>
<div class="chapter">
<div class="inner_page">
<p class="block_"> </p>
<h1 class="block_114" id="id_Toc151366860">Your Choice</h1>
<p class="block_"> </p>
<p class="block_2">Some rose bright and early; they got there first and gained the world.</p>
<p class="block_2">Others remained sleeping; they stayed put and ended with nothing.</p>
<p class="block_2">Some played along, singing and dancing; they won the jackpot.</p>
<p class="block_2">Those that did not play ball found themselves failures.</p>
<p class="block_2">Others stepped up, reaching for the top; they got wealthy.</p>
<p class="block_2">But some stayed sitting and remained stuck in their ways.</p>
<p class="block_2">Some opened their eyes, saw the opportunities, and jumped in. They were fulfilled.</p>
<p class="block_2">Those that opted out became immune and unaware; they were forgotten.</p>
<p class="block_2">Others were strong and brave. They walked up to it and conquered.</p>
<p class="block_2">Those that cowered and shied away from it were shamelessly defeated.</p>
<p class="block_2">Some were quick and prepared, reached the finishing line, and won the game.</p>
<p class="block_2">Others were not up to scratch; they became insignificant and faded into oblivion.</p>
<p class="block_2">Some learned about it, mastered it, and became knowledgeable.</p>
<p class="block_2">Those that loitered and wavered were left dumbfounded and ignorant.</p>
<p class="block_2">Some were clever and driven by their dreams. They surpassed and became heroes.</p>
<p class="block_2">The mediocre and lazy missed the point. They were left out and missed out.</p>
<p class="block_2">Those that were enlightened walked in the light with confidence and wisdom.</p>
<p class="block_2">Others remained in the dark; they became desperate, and they despaired.</p>
<p class="block_2">Some were filled with hope. They overcame and became great.</p>
<p class="block_2">Others lost faith and became worthless.</p>
<p class="block_2">Some gracefully accepted it and were richly rewarded.</p>
<p class="block_2">Others grasped it by the neck; they were choked.</p>
<p class="block_2">Those that were patient reaped the benefits, enjoying the interest.</p>
<p class="block_2">But those filled with impatience got wild. They were lost in the wilderness and perished.</p>
<p class="block_2">Some were kind and nurturing. They received honour and were loved.</p>
<p class="block_2">Those that were cruel and uncompromising were filled with guilt and felt unworthy.</p>
<p class="block_2">Others sought peace and arbitration; they were earthly rewarded.</p>
<p class="block_2">Those that sought to fight and brawl were doomed to the graves.</p>
<p class="block_2">Some grabbed it with both hands and succeeded.</p>
<p class="block_2">Others let it slip through their fingers and lost it all.</p>
<p class="block_2">Some heard about it, mentored it, and profited.</p>
<p class="block_2">Those that ignored it ended with a loss.</p>
<p class="block_2">Some spoke out and advocated for others. They were awarded accolades.</p>
<p class="block_2">Whilst those that remained silent were never heard and remained obscure.</p>
<p class="block_2">Some saw it coming, grabbed it by both hands, and became powerful.</p>
<p class="block_2">Others were blinded by its light and never got a chance.</p>
<p class="block_3" id="calibre_pb_7"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_006.vue?65082a89